export default __webpack_public_path__ + "static/media/grafema_+-identity_05.2eb94ca8.jpg";